export default "__VITE_ASSET__Hp9V6Stk__"